import { Component, OnInit, Directive, Input, HostListener, ViewChild } from '@angular/core';

import { Router } from '@angular/router';
import { CognitoUtil } from '../../../../shared/services/cognito.service';
import { ReportsService } from '../../../../shared/services/reports.service';
import { LocalUserService } from '../../../../shared/services/localUser';
import { Subject } from 'rxjs/Subject';
import { Chart } from 'chart.js';
import { MatDialog, MatDialogRef, MatSnackBar, MatPaginator, MatTableDataSource } from '@angular/material';

@Component({
    selector: 'calendar-cases',
    templateUrl: './calendar.cases.component.html'
})
export class CalendarCasesComponent implements OnInit {


    @ViewChild('calendarCasesTable') calendarCasesTable: any;

    @Input() userAttributes: Subject<any>;
    displayedColumns: string[] = ['case_number', 'created_date','modified_date', 'status'];
    @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
        this.calendarCasesTableData.paginator = paginator;
    }

    view: any[] = [null, 400];

    showTable = false;

    orgId = null;
    userId = null;
    token: string;

    loading = true;

    calendarCasesChartData = [];
    calendarCasesData = [];
    calendarCasesTableData = new MatTableDataSource<any>();

    chartLabel = [];

    chartData = [];
    chartColors = [];

    error: string;

    color = ['#49AFD9', '#A6D8E7', '#C1CDD4', '#798893', '#00B7D6', '#ff4000', '#ffff00', '#0065AB', '#e60000', '#ff00ff', '#000099', '#ff66d9', '#ff9933', '#33ff33', '#ff6633', '#b30000', '#00ffff', '#40ff00'];

    colorScheme = {
        domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
    };

    // pie
    explodeSlices = false;

    toolTipGenerator = function (event) {
        let text;
        if (event && event.data) {
            text = `${event.data.name} - ${event.data.value}`;
        }
        return text;
    };

    constructor(
        private reportsService: ReportsService,
        private router: Router,
        private cognito: CognitoUtil,
        private localUser: LocalUserService,
        public snackBar: MatSnackBar,
    ) {

    }

    ngOnInit() {
        this.userId = this.localUser.getUserId();
        this.orgId = this.localUser.getOrganizationId();
        this.getCalendarCases();
    }

    dynamicColors() {
        var r = Math.floor(Math.random() * 255);
        var g = Math.floor(Math.random() * 255);
        var b = Math.floor(Math.random() * 255);
        return "rgb(" + r + "," + g + "," + b + ")";
    };

    getCalendarCases() {
        this.reportsService.getCalendarCases(this.orgId, this.userId)
            .subscribe((data) => {

                let keys = Object.keys(data);
                let formedData = [];

                for (let i = 0; i < keys.length; i++) {
                    let newObject = {
                        name: keys[i],
                        value: data[keys[i]]
                    };
                    formedData.push(newObject);
                }

                this.calendarCasesChartData = formedData;
                this.loading = false;
                let index = 0;
                this.calendarCasesChartData.forEach(item => {
                    this.chartLabel.push(item.name);
                    this.chartData.push(item.value);
                    // this.chartColors.push(this.dynamicColors());
                    this.chartColors.push(this.color[index]);
                    index = index + 1;
                });
                this.barChart();
            }, error => {
                this.loading = false;
                this.error = 'Server Not Responding';
                this.snackBar.open(this.error, '', {
                    duration: 2000,
                });
            });


    }

    barChart() {
        $('#calendarCases').remove()
        $('#parentCalendarCases').append('<canvas id="calendarCases"></canvas>')
        var ctx = document.getElementById("calendarCases")
        new Chart(ctx, {
            type: 'bar',
            data: {
                labels: this.chartLabel,
                datasets: [
                    {
                        label: "",
                        backgroundColor: this.chartColors,
                        data: this.chartData
                    }
                ]
            },
            options: {
                onClick: (mouseEvent, chart) => {
                    let index = chart[0]._index
                    let type = chart[0]._model.label
                    this.onChartClick(type, 'calendarCasesTableData', this.calendarCasesData = [])
                },
                legend: { display: false },
                scales: {
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Year'
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            stepSize: 1
                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'No. of Cases'
                        }
                    }]
                },
                title: {
                    display: true,
                    text: 'Annual Cases'
                }
            }
        });


    }

    onPieSectorClick(event, tableData, reportsData) {
        this[tableData] = reportsData[event.name];
        this.showTable = true;
    }

    onChartClick(event, tableData, reportsData) {
        this.loading = true;
        this.reportsService.getReportsCases(this.orgId, this.userId, 'CalendarCases', event)
            .subscribe(result => {
                this.calendarCasesTableData.data = result;
                this.showTable = true;
                this.loading = false;
            }, error => {
                this.loading = false;
                this.error = 'Server Not Responding';
                this.snackBar.open(this.error, '', {
                    duration: 2000,
                });
            });
    }

    toggleExpandRow(row, tableType) {
        this[tableType].rowDetail.toggleExpandRow(row);
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/reports/calendar-cases/calendar.cases.component.ts